(() => {
  'use strict';
  const $  = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const tpl = n => $$(`[data-dc-tpl="${n}"]`);

  /* ---- ad touches (2026-10-09, 📊 ask relayed by the operator: "pass it to the funnel site changer") --------------
     Remembers which Meta ad first brought this browser (first touch, kept 30 days) and which ad it clicked last (last touch,
     replaced on every ad click), so the order can record both. Ad ids only (no personal data), in localStorage on this
     domain. The Buy tap passes them to the Funnelish checkout as ft_* / lt_* params. */
  const touch = (() => {
    try {
      const q = new URLSearchParams(location.search), g = k => (q.get(k) || '').slice(0, 64);
      const t = { c: g('utm_campaign') || g('campaign_id'), s: g('utm_term') || g('adset_id'), a: g('utm_content') || g('ad_id'),
                  src: g('utm_source'), at: Math.floor(Date.now() / 1000) };
      const isAd = !!(t.c || t.a || q.get('fbclid'));
      const rd = k => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
      let ft = rd('rc_ft'), lt = rd('rc_lt');
      if (ft && t.at - (ft.at || 0) > 30 * 86400) ft = null;
      if (isAd) { if (!ft) { ft = t; localStorage.setItem('rc_ft', JSON.stringify(ft)); } lt = t; localStorage.setItem('rc_lt', JSON.stringify(lt)); }
      return { ft, lt };
    } catch (e) { return {}; }
  })();

  /* ---- gallery: thumbnails swap the hero image (responsive source) ------ */
  const HERO = $('[data-dc-tpl="28"]');
  const GAL = ['raw-v209-hero-sq', 'raw-v209-gal2-sq', 'raw-v209-gal3-sq', 'raw-v209-gal4-sq'];
  const assetBase = (() => {
    const cur = HERO ? getComputedStyle(HERO).backgroundImage : '';
    const m = cur.match(/url\(["']?(.*?)[\w.-]+\.webp/);
    return m ? m[1] : 'assets/';
  })();
  /* Gallery squares are cropped from the 1200x736 landscape masters (sides trimmed,
     full product height preserved), so 800 is their native ceiling - never request
     a width that would upscale past the master. */
  const WIDTHS = { 'raw-v209-hero-sq': [420, 760, 1024],
                   'raw-v209-gal2-sq': [420, 760, 800],
                   'raw-v209-gal3-sq': [420, 760, 800],
                   'raw-v209-gal4-sq': [420, 760, 800] };
  const DEFAULT_WIDTHS = [420, 760, 1200];
  // CSS px alone under-serves high-DPR phones: a 420px file stretched over ~1100
  // device px is what made the product art look mushy. Size for real pixels.
  const widthFor = name => {
    const need = innerWidth * Math.min(devicePixelRatio || 1, 3);
    const ws = WIDTHS[name] || DEFAULT_WIDTHS;
    return ws.find(w => w >= need) || ws[ws.length - 1];
  };
  const thumbs = tpl(31);
  let galIndex = 0;
  const showGallery = i => {
    if (!HERO || !GAL[i]) return;
    galIndex = i;
    if (i === 0) {
      /* Frame 0 is what the CSS + <link rel=preload> already resolved. Setting our own
         URL here made the browser discard the preloaded LCP image and fetch a second
         hero variant, pushing LCP out. Hand frame 0 back to the stylesheet. */
      HERO.style.removeProperty('background-image');
      thumbs.forEach((t, n) => {
        const on = n === i;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        t.style.borderColor = on ? '#C8102E' : 'transparent';
      });
      return;
    }
    HERO.style.setProperty('background-image',
      `url("${assetBase}${GAL[i]}-${widthFor(GAL[i])}.webp")`, 'important');
    thumbs.forEach((t, n) => {
      const on = n === i;
      t.setAttribute('aria-current', on ? 'true' : 'false');
      t.style.borderColor = on ? '#C8102E' : 'transparent';
    });
  };
  thumbs.forEach((btn, i) => {
    btn.setAttribute('role', 'button');
    btn.setAttribute('aria-label', `View product image ${i + 1}`);
    btn.addEventListener('click', () => showGallery(i));
  });
  addEventListener('resize', () => showGallery(galIndex), { passive: true });
  showGallery(0);

  /* ---- offers: tile selection drives CTA, savings and both bars -------- */
  const OFFERS = {
    pack3:  { name: '3 Bottles + Free Roll-On', price: '$75',
              cta: 'GET 78% OFF TODAY — $75',
              save: 'Total value $335.85 · You save $260.85 (78%)',
              value: '$335.85', claim: 'Claim 78% off today →', finH: 'Everything you get for $75.',
              incl: 'Free roll-on · free express shipping · 60-day guarantee',
              bottles: ['3 full-size bottles', '$99 list each · 30 ml'], rollon: true,
              variant: document.body.dataset.rawB2g1Variant },
    single: { name: '1 Full-Size Bottle', price: '$39.90',
              cta: 'GET 60% OFF TODAY — $39.90',
              save: 'Was $99 · You save $59.10 (60%)',
              value: '$99', claim: 'Claim 60% off today →', finH: 'Everything you get for $39.90.',
              incl: 'Free express shipping · 60-day guarantee',
              bottles: ['1 full-size bottle', '$99 list · 30 ml'], rollon: false,
              variant: document.body.dataset.rawSingleVariant }
  };
  const tiles = tpl(46);
  const cta = tpl(64)[0];
  const saveLine = cta && cta.nextElementSibling;
  const topBar = $('a[href="#v203-top"][data-dc-tpl="4"], body > a');
  let current = 'pack3';
  /* red top bar follows the selected tier (2026-09-23): bundle keeps the shipped markup text
     byte-for-byte (captured here, restored on re-select); single swaps to its own offer. */
  const topSale = $('[data-dc-tpl="7"]');
  const topOffer = $('[data-dc-tpl="8"] .sc-interp') || $('[data-dc-tpl="8"]');
  const TOPBAR = { pack3: [topSale && topSale.textContent, topOffer && topOffer.textContent],
                   single: ['Black Friday \u00b7 60% off \u{1F525}', '1 Full-Size Bottle for $39.90'] };
  const paintTop = key => {
    const t = TOPBAR[key]; if (!t) return;
    if (topSale && t[0] != null && topSale.textContent !== t[0]) topSale.textContent = t[0];
    if (topOffer && t[1] != null && topOffer.textContent !== t[1]) topOffer.textContent = t[1];
  };

  const paint = key => {
    const o = OFFERS[key]; if (!o) return;
    current = key;
    if (cta) cta.textContent = o.cta;
    if (saveLine && /save|value|was/i.test(saveLine.textContent)) saveLine.textContent = o.save;
    tiles.forEach((t, i) => {
      const on = (i === 0) === (key === 'pack3');
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
      t.style.borderColor = on ? '#C8102E' : '#e4e4e4';
      t.style.background  = on ? '#fdf7f7' : '#fff';
    });
    const sticky = $('[data-raw-sticky-name]');
    if (sticky) sticky.textContent = `${o.price} · ${o.name}`;
    if (topBar) {
      const c = topBar.querySelector('[data-raw-topoffer]');
      if (c) c.textContent = `${o.name} for ${o.price}`;
    }
    paintTop(key);
    /* every price-bearing CTA below the fold follows the selected offer */
    const setT = (sel, txt) => { const n = $(sel); if (n) n.textContent = txt; };
    setT('.rb76f7b58 .r11d7c4af', o.claim); setT('.r25461d56', o.value); setT('.rd8c88f5f', o.price); setT('.ra30e0f25', o.incl);
    setT('.rawfin-h', o.finH); setT('.rawfin-cta', o.claim);
    const li = $$('.rawfin-list li');
    if (li[0] && li[0].children.length > 1) { li[0].children[0].textContent = o.bottles[0]; li[0].children[1].textContent = o.bottles[1]; }
    if (li[1]) li[1].hidden = !o.rollon;
    const fv = $('.rawfin-value'); if (fv) { const s = fv.querySelector('s'), st = fv.querySelector('strong'); if (s) s.textContent = o.value; if (st) st.textContent = o.price; }
    document.querySelectorAll('[data-raw-variant]').forEach(n => { n.value = o.variant; });
    document.dispatchEvent(new CustomEvent('raw:offer'));
  };
  tiles.forEach((t, i) => {
    t.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
    t.addEventListener('click', () => paint(i === 0 ? 'pack3' : 'single'));
  });

  /* ---- accordions + FAQ: single-open per group ------------------------- */
  $$('[data-raw-acc]').forEach(btn => {
    const panel = btn.nextElementSibling;
    if (!panel || !panel.hasAttribute('data-raw-acc-panel')) return;
    const group = btn.closest('section, main, div');
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      if (group) $$('[data-raw-acc]', group).forEach(o => {
        if (o === btn) return;
        o.setAttribute('aria-expanded', 'false');
        const p = o.nextElementSibling;
        if (p && p.hasAttribute('data-raw-acc-panel')) p.style.display = 'none';
        const m = o.querySelector('span:last-child');
        if (m && /[+−]/.test(m.textContent)) m.textContent = '+';
      });
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.display = open ? 'none' : 'block';
      const mark = btn.querySelector('span:last-child');
      if (mark && /[+−]/.test(mark.textContent)) mark.textContent = open ? '+' : '−';
    });
  });

  /* ---- review expander -------------------------------------------------- */
  const exp = tpl(432)[0];
  if (exp) {
    const wall = exp.previousElementSibling;
    const cards = wall ? [...wall.children] : [];
    const KEEP = 5;
    let open = false;
    const apply = () => {
      cards.forEach((c, i) => { c.style.display = (open || i < KEEP) ? 'block' : 'none'; });
      exp.textContent = open ? 'SHOW FEWER' : `SHOW MORE REVIEWS`;

      exp.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    if (cards.length > KEEP) { apply(); exp.addEventListener('click', () => { open = !open; apply(); }); }
  }

  /* ---- countdown: drives the top bar MIN/SEC, the price-lock pill and the sticky bar */
  const pad = n => String(n).padStart(2, '0');
  let secs = 600;
  const topMin = $('[data-dc-tpl="12"] .sc-interp') || $('[data-dc-tpl="12"]');
  const topSec = $('[data-dc-tpl="16"] .sc-interp') || $('[data-dc-tpl="16"]');
  const pillClock = $('[data-dc-tpl="63"] .sc-interp') || $('[data-dc-tpl="63"]');
  const barClock  = () => $('[data-raw-stickybar] [data-dc-tpl="469"] .sc-interp')
                       || $('[data-raw-stickybar] [data-dc-tpl="469"]');
  /* v209d (2026-10-06, agency countdown test, relayed operator ask): measure seconds from page start to the Buy tap and
     whether the 10:00 countdown had already hit zero. The timer itself is unchanged: it still resets to 10:00 (operator,
     2026-09-23). TimerExpired fires each time it reaches 00:00; BuyTap carries seconds_on_page / timer_expired / timer_left;
     the checkout link carries rc_sec / rc_tx so the Funnelish side can tie it to the order. */
  let timerExpiries = 0;
  const secsOnPage = () => Math.round(((window.performance && performance.now) ? performance.now() : 0) / 1000);
  const tick = () => {
    secs = secs > 0 ? secs - 1 : 600;
    if (secs === 0) {
      timerExpiries++;
      try { if (typeof window.rawMetaBeacon === 'function') window.rawMetaBeacon('TimerExpired', { seconds_on_page: secsOnPage(), expiry_n: timerExpiries }); } catch (e) {}
    }
    const mm = pad(Math.floor(secs / 60)), ss = pad(secs % 60);
    if (topMin) topMin.textContent = mm;
    if (topSec) topSec.textContent = ss;
    const v = `${mm}:${ss}`;
    if (pillClock) pillClock.textContent = v;
    const bc = barClock(); if (bc) bc.textContent = v;
  };
  tick(); setInterval(tick, 1000);

  /* ---- sticky purchase bar: mirrors v208 (appears past 760px) ------------ */
  const bar = $('[data-raw-stickybar]');
  if (bar) {
    const sync = () => {
      const o = OFFERS[current];
      const name = bar.querySelector('[data-dc-tpl="467"]');
      if (name && o) name.innerHTML =
        `<span class="sc-interp">${o.price}</span> · <span class="sc-interp">${o.name}</span>`;
    };
    const onScroll = () => { bar.hidden = scrollY < 760; };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll(); sync();
    document.addEventListener('raw:offer', sync);
  }


  /* ---- checkout: same contract as the accepted v114 build ---------------- */
  let checkoutPending = false;
  const startCheckout = async (btn) => {
    if (checkoutPending) return;
    const o = OFFERS[current];
    if (!o || !o.variant) return;
    checkoutPending = true;
    /* Meta: custom BuyTap (was AddToCart until 2026-09-24: Shopify checkout sends its own AddToCart, so a page ATC double-counted every tap) as a beacon before the redirect, so navigation cannot drop it. InitiateCheckout is deliberately NOT sent here (v210, 2026-09-03): Shopify's checkout fires checkout_started as the single InitiateCheckout source, same as the reveal page (v110r19), so IC means a real checkout load on every RAW page. */
    try {
      if (typeof window.rawMetaBeacon === 'function') {
        const p = { content_name: o.name, content_ids: [String(o.variant)], content_type: 'product',
                    currency: 'USD', value: Number(String(o.price).replace(/[^0-9.]/g, '')) || 0, num_items: 1,
                    seconds_on_page: secsOnPage(), timer_left: secs, timer_expired: timerExpiries > 0 ? 'yes' : 'no', timer_expiries: timerExpiries };
        window.rawMetaBeacon('BuyTap', p);
      }
    } catch (e) {}
    const label = btn && btn.textContent;
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding\u2026'; }
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      /* One line in the cart, always — now via a Shopify cart permalink (/cart/<variant>:1) instead of
         cart/clear.js + cart/add.js. The permalink builds the checkout from exactly the one variant named
         in the URL (the selected offer: pack3 or single), so repeat taps or a stale cart cannot accumulate
         lines. It is a full navigation, so Shopify can show its own connection challenge and continue;
         the previous fetch() calls were answered with 429 under that challenge and stranded the customer
         on "Sorry — checkout could not start" after the Meta beacons had already fired. Same variants,
         same store discount at checkout (verified 2026-09-03: $335.85 -> $99.00). */
      /* v209c (2026-09-28, operator go): buyers go to the Funnelish checkout on secure.rawchemistry.com (3-pack -> /checkout,
         single -> /checkout-single). Ad-click params ride along, and rcdl carries this page's countdown so the checkout timer
         continues instead of restarting. The Shopify cart permalink below stays as the fallback for any other offer. */
      const FNSH = { pack3: 'https://secure.rawchemistry.com/checkout', single: 'https://secure.rawchemistry.com/checkout-single' };
      if (FNSH[current]) {
        const u = new URL(FNSH[current]);
        new URLSearchParams(location.search).forEach((v, k) => {
          if (/^(utm_[a-z_]+|fbclid|gclid|ttclid|campaign_id|adset_id|ad_id|_kx)$/i.test(k)) u.searchParams.set(k, v);
        });
        u.searchParams.set('rcdl', String(Date.now() + Math.max(1, secs) * 1000));
        u.searchParams.set('rc_sec', String(secsOnPage())); u.searchParams.set('rc_tx', String(timerExpiries));
        for (const [p, v] of [['ft', touch.ft], ['lt', touch.lt]]) if (v) for (const k of ['c', 's', 'a', 'src', 'at']) if (v[k]) u.searchParams.set(p + '_' + k, String(v[k]));
        window.location.href = u.toString();
        return;
      }
      window.location.href = `${root.replace(/\/?$/, '/')}cart/${encodeURIComponent(String(o.variant))}:1`;
      return;
    } catch (err) {
      if (btn) { btn.textContent = label; btn.removeAttribute('aria-busy'); }
      const note = document.createElement('div');
      note.setAttribute('role', 'alert');
      note.style.cssText = 'margin-top:8px;font-size:13px;font-weight:700;color:#8a1122;text-align:center';
      note.textContent = 'Sorry \u2014 checkout could not start. Please try again.';
      if (btn && !btn.nextElementSibling?.getAttribute('role')) btn.after(note);
    } finally {
      checkoutPending = false;
    }
  };
  // primary CTA, the sticky bar button, and every "claim/get" link
  const ctaNodes = () => [
    ...tpl(64),
    ...$$('[data-raw-stickybar] button'),
    ...$$('a[href="#v203-top"]')
  ].filter(Boolean);
  ctaNodes().forEach(el => {
    el.addEventListener('click', ev => { ev.preventDefault(); startCheckout(el); });
  });


  /* ---- UGC rail: tap a card to swap its poster for an inline video (mirrors the canonical v110 player) */
  const ugcCards = $$('[data-raw-ugc-src]');
  const ugcLaunch = (card) => {
    const existing = card.querySelector('video');
    ugcCards.forEach(o => { const v = o.querySelector('video'); if (v && v !== existing) v.pause(); });
    if (existing) { existing.play().catch(() => {}); return; }
    const src = card.dataset.rawUgcSrc; if (!src) return;
    const poster = card.querySelector('[role="presentation"], [role="img"]');
    const bg = poster ? (getComputedStyle(poster).backgroundImage.match(/url\(["']?(.*?)["']?\)/) || [])[1] : '';
    const video = document.createElement('video');
    video.controls = true; video.playsInline = true; video.setAttribute('playsinline', ''); video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto'; if (bg) video.poster = bg; video.src = src;
    video.setAttribute('aria-label', card.getAttribute('aria-label') || 'Customer reaction video');
    card.setAttribute('data-playing', ''); card.appendChild(video);
    const unmute = document.createElement('button'); unmute.type = 'button'; unmute.className = 'raw-unmute';
    unmute.textContent = 'TAP FOR SOUND'; unmute.hidden = true;
    unmute.addEventListener('click', ev => { ev.stopPropagation(); video.muted = false; unmute.hidden = true; video.play().catch(() => {}); });
    card.appendChild(unmute);
    video.play().catch(() => { video.muted = true; unmute.hidden = false; video.play().catch(() => {}); });
  };
  ugcCards.forEach(card => {
    card.addEventListener('click', ev => { if (ev.target.closest('video, .raw-unmute')) return; ev.preventDefault(); ugcLaunch(card); });
    card.addEventListener('keydown', ev => { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); ugcLaunch(card); } });
  });

  paint('pack3');
  /* marquee: pin the animation inline with !important so async CSS order or a reduced-motion
     rule can never freeze it (it was frozen for every reduce-motion user). */
  const mqTrack = $('.rf41aaaff');
  if (mqTrack) { [['animation-name','rawTicker'],['animation-duration','24s'],['animation-timing-function','linear'],['animation-iteration-count','infinite'],['animation-play-state','running']].forEach(([k,v]) => mqTrack.style.setProperty(k, v, 'important')); }

  /* Horizontal review rails ship dot indicators in the markup, but nothing was ever
     bound to them: the dots never tracked the swipe and were not clickable. Wired here
     generically (any overflow-x rail whose dot row has one dot per card). */
  const wireRails = () => {
    /* Cheap geometric filter FIRST - getComputedStyle on every node in the document
       was costing ~80ms of blocking time per pass. Only overflowing multi-child
       elements are worth a style read, and there are a handful of those. */
    [...document.querySelectorAll('div,section,ul')].forEach(rail => {
      if (rail.dataset.rawRailWired) return;
      if (rail.children.length < 2) return;
      if (rail.scrollWidth <= rail.clientWidth + 4) return;
      if (!/auto|scroll/.test(getComputedStyle(rail).overflowX)) return;
      if (rail.closest('[aria-hidden="true"]')) return;
      let dots = null, p = rail;
      for (let i = 0; i < 4 && p && !dots; i++) {
        p = p.parentElement; if (!p) break;
        dots = [...p.querySelectorAll('*')].find(e => e !== rail &&
          e.children.length === rail.children.length &&
          [...e.children].every(c => { const b = c.getBoundingClientRect();
            return b.width > 2 && b.width <= 14 && Math.abs(b.width - b.height) < 5; }));
      }
      if (!dots) return;
      rail.dataset.rawRailWired = '1';
      const kids = [...dots.children];
      const ACTIVE = getComputedStyle(kids[0]).backgroundColor;
      const IDLE = getComputedStyle(kids[1] || kids[0]).backgroundColor;
      const step = () => rail.scrollWidth / rail.children.length;
      const paint = () => {
        const a = Math.max(0, Math.min(kids.length - 1, Math.round(rail.scrollLeft / step())));
        kids.forEach((d, i) => {
          d.style.backgroundColor = i === a ? ACTIVE : IDLE;
        });
      };
      let ticking = false;
      rail.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { paint(); ticking = false; });
      }, { passive: true });
      /* Deliberately NOT focusable/clickable: these dots are 6px and ~14px apart, so
         interactive targets fail WCAG target-size, and the generic detector can match
         decorative node rows inside aria-hidden containers. They are status indicators;
         the rail itself is the swipe surface. */
      dots.setAttribute('aria-hidden', 'true');
      paint();
    });
  };
  /* Reading scrollWidth across the document forces synchronous layout; doing that while
     sections are still hydrating cost ~90ms of blocking time. The rails sit well below the
     fold, so defer until the user actually scrolls - they cannot reach a rail without it. */
  let railsDone = false;
  const runRails = () => {
    if (railsDone) return;
    railsDone = true;
    ('requestIdleCallback' in window)
      ? requestIdleCallback(wireRails, { timeout: 1500 })
      : setTimeout(wireRails, 60);
  };
  addEventListener('scroll', runRails, { passive: true, once: true });
  addEventListener('touchstart', runRails, { passive: true, once: true });

})();
